import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import { mergeProps } from '../../utils/with-default-props';
import React, { useEffect, useRef, useState } from 'react';
import { useLockFn, useThrottleFn } from 'ahooks';
import { withNativeProps } from '../../utils/native-props';
import { getScrollParent } from '../../utils/get-scroll-parent';
import { useConfig } from '../config-provider';
import DotLoading from '../dot-loading';

function isWindow(element) {
  return element === window;
}

var classPrefix = "adm-infinite-scroll";
var defaultProps = {
  threshold: 250,
  children: function children(hasMore, failed, retry) {
    return React.createElement(InfiniteScrollContent, {
      hasMore: hasMore,
      failed: failed,
      retry: retry
    });
  }
};
export var InfiniteScroll = function InfiniteScroll(p) {
  var props = mergeProps(defaultProps, p);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      failed = _useState2[0],
      setFailed = _useState2[1];

  var doLoadMore = useLockFn(function (isRetry) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return props.loadMore(isRetry);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              setFailed(true);
              throw _context.t0;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));
  });
  var elementRef = useRef(null); // Prevent duplicated trigger of `check` function

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      flag = _useState4[0],
      setFlag = _useState4[1];

  var nextFlagRef = useRef(flag);

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      scrollParent = _useState6[0],
      setScrollParent = _useState6[1];

  var _useThrottleFn = useThrottleFn(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var element, parent, rect, elementTop, current, nextFlag;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(nextFlagRef.current !== flag)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (props.hasMore) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              element = elementRef.current;

              if (element) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              if (element.offsetParent) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return");

            case 9:
              parent = getScrollParent(element);
              setScrollParent(parent);

              if (parent) {
                _context2.next = 13;
                break;
              }

              return _context2.abrupt("return");

            case 13:
              rect = element.getBoundingClientRect();
              elementTop = rect.top;
              current = isWindow(parent) ? window.innerHeight : parent.getBoundingClientRect().bottom;

              if (!(current >= elementTop - props.threshold)) {
                _context2.next = 22;
                break;
              }

              nextFlag = {};
              nextFlagRef.current = nextFlag;
              _context2.next = 21;
              return doLoadMore(false);

            case 21:
              setFlag(nextFlag);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, {
    wait: 100,
    leading: true,
    trailing: true
  }),
      check = _useThrottleFn.run; // Make sure to trigger `loadMore` when content changes


  useEffect(function () {
    check();
  });
  useEffect(function () {
    var element = elementRef.current;
    if (!element) return;
    if (!scrollParent) return;

    function onScroll() {
      check();
    }

    scrollParent.addEventListener('scroll', onScroll);
    return function () {
      scrollParent.removeEventListener('scroll', onScroll);
    };
  }, [scrollParent]);

  function retry() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setFailed(false);
              _context3.next = 3;
              return doLoadMore(true);

            case 3:
              setFlag(nextFlagRef.current);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  }

  return withNativeProps(props, React.createElement("div", {
    className: classPrefix,
    ref: elementRef
  }, typeof props.children === 'function' ? props.children(props.hasMore, failed, retry) : props.children));
};

var InfiniteScrollContent = function InfiniteScrollContent(props) {
  var _useConfig = useConfig(),
      locale = _useConfig.locale;

  if (!props.hasMore) {
    return React.createElement("span", null, locale.InfiniteScroll.noMore);
  }

  if (props.failed) {
    return React.createElement("span", null, React.createElement("span", {
      className: "".concat(classPrefix, "-failed-text")
    }, locale.InfiniteScroll.failedToLoad), React.createElement("a", {
      onClick: function onClick() {
        props.retry();
      }
    }, locale.InfiniteScroll.retry));
  }

  return React.createElement(React.Fragment, null, React.createElement("span", null, locale.common.loading), React.createElement(DotLoading, null));
};